import React, { useState, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import propTypes from "prop-types";

import Inquiry from "./Inquiry";
import CartBox from "./CartBox";
import { CheckoutContainer } from "./styles";

export default function Checkout(props) {
  const [left, setLeft] = useState(0);
  const [padding, setPadding] = useState(0);

  useEffect(() => {
    resize()
    window.addEventListener("resize", resize);
    if (localStorage.getItem("SFLead") !== null) {
      props.clearSFLead();
    }
    return () => window.removeEventListener("resize", resize);
  }, []);

  const resize = () => {
    if (window.innerWidth > 1680) {
      setLeft(600);
      setPadding(150);
    } else {
      setLeft(window.innerWidth - 1000);
      setPadding(100);
    }
  };
  return (
    <CheckoutContainer>
      <section
        className="checkout"
        style={{
          marginLeft: `${left}px`,
          paddingLeft: `${padding}px`,
        }}
      >
        {process.env.REACT_APP_ALLOW_RECAPTCHA === "true" ? (
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
            language="en"
            tabindex="666"
          >
            <Inquiry
              newInquiry={props.newInquiry}
              newLead={props.newLead}
              profile={props.auth.userProfile.profile}
              userToken={props.userToken}
              mobile={props.mobile}
              videos={props.videos}
              lead={props.lead}
            />
          </GoogleReCaptchaProvider>
        ) : (
          <Inquiry
            newInquiry={props.newInquiry}
            newLead={props.newLead}
            profile={props.auth.userProfile.profile}
            userToken={props.userToken}
            mobile={props.mobile}
            videos={props.videos}
            lead={props.lead}
          />
        )}

        {props.videos && props.videos.length > 0 ? (
          <CartBox
            loading={props.loading}
            userToken={props.userToken}
            email={props.username}
            videos={props.videos}
          />
        ) : (
          ""
        )}

        <div className="clearer" />
      </section>
    </CheckoutContainer>
  );
}

Checkout.propTypes = {
  auth: propTypes.object,
  loading: propTypes.bool,
  videos: propTypes.array,
  lead: propTypes.string
}